/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Wizard_Toast_Sync_SuccessInputs */



/**
* | output |
* | --- |
* | "Space synchronized successfully" |
*
* @param {Spaces_Wizard_Toast_Sync_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_wizard_toast_sync_success = /** @type {((inputs?: Spaces_Wizard_Toast_Sync_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Wizard_Toast_Sync_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Space erfolgreich synchronisiert")
	return /** @type {LocalizedString} */ ("Space synchronized successfully")
});